import React from 'react'
import { timeLineData } from '../../constants';
import { Timeline } from "../ui/Timeline";
import { useStateContext } from '../../context/ContextProvider';
const AboutUSTimeline = () => {
  return (
    <div> <TimelineD /></div>
  )
}


export function TimelineD() {
  const {currentLang}=useStateContext()
  const isAr=currentLang==="ar"



  return (
    <div className="relative mt-12 md:mt-16 lg:mt-36 w-full overflow-clip">
      <Timeline data={timeLineData.items} title={isAr ? timeLineData.title_Ar :timeLineData.title_En}  subtitle={isAr ? timeLineData.subtitle_Ar :timeLineData.subtitle_En}/>
    </div>
  );
}

export default AboutUSTimeline